import {
  ACTIVATE_PREPAIDCARD_SUCCESS,
  ACTIVATE_PREPAIDCARD_FAILED,
  ACTIVATE_PREPAIDCARD_INVALID_REQUEST,
  LOADING_ACTIVATE_PREPAIDCARD,
  ACTIVATE_PREPAIDCARD_NOTFOUND,
  RESET_ACTIVATE_PREPAIDCARD
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  status: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ACTIVATE_PREPAIDCARD:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        status: {}
      };
    case ACTIVATE_PREPAIDCARD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        status: action.payload.status
      };

    case ACTIVATE_PREPAIDCARD_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case ACTIVATE_PREPAIDCARD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case ACTIVATE_PREPAIDCARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        status: action.payload.status
      };

    case RESET_ACTIVATE_PREPAIDCARD:
      return (state = initialState);

    default:
      return state;
  }
};
